"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _ramda = require("ramda");

var R = _interopRequireWildcard(_ramda);

var _reactRedux = require("react-redux");

var _redial = require("redial");

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

var _Home = require("../Home/Home");

var _components = require("../../components");

var _QouteSection = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/QouteSection");

var _QouteSection2 = _interopRequireDefault(_QouteSection);

var _Slider = require("@quixeltools/quixel-ui-library/dist/components/common/website/Slider");

var _Slider2 = _interopRequireDefault(_Slider);

var _ImageWithOverlayText = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/ImageWithOverlayText");

var _ImageWithOverlayText2 = _interopRequireDefault(_ImageWithOverlayText);

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _softwares = require("../../redux/modules/softwares");

var _utils = require("../../utils");

var _cloudFront = require("../../utils/cloudFront");

var cf_utils = _interopRequireWildcard(_cloudFront);

var _utils2 = require("../../EpicMigration/utils");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buttonsGroup = (0, _glamor.css)({
  marginTop: (0, _css.unitRem)(3)
});

var btn = function btn(first) {
  return (0, _glamor.css)({
    display: "block",
    margin: "auto",
    marginTop: !first && (0, _css.unitRem)(0.75)
  }, minWidth(breakpoints.small)({
    display: "inline-block",
    marginLeft: !first && (0, _css.unitRem)(1)
  }), polyfluid({
    width: {
      small: "100%",
      medium: 12.6875,
      large: [12.6875, 14.25]
    },
    maxWidth: {
      small: [16, 20],
      mediumLarge: "100%"
    }
  }));
};

var Mixer = (_dec = (0, _redial.provideHooks)({
  defer: function defer(_ref) {
    var dispatch = _ref.store.dispatch;

    return dispatch((0, _softwares.loadMixerUpdater)());
  }
}), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    softwares: state.softwares,
    loggedIn: state.auth.loggedIn,
    subscription: state.user && state.user.subscription
  };
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Mixer, _React$Component);

  function Mixer(props) {
    (0, _classCallCheck3.default)(this, Mixer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Mixer.__proto__ || (0, _getPrototypeOf2.default)(Mixer)).call(this, props));

    _this.state = {
      platform: "Windows"
    };
    _this.renderContactUsForm = _this.renderContactUsForm.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Mixer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var platform = (0, _utils.detectOperatingSystem)();

      this.setState({ platform: platform });
    }
  }, {
    key: "renderContactUsForm",
    value: function renderContactUsForm(title, description, tag, initialValues) {
      this.context.dialogs.custom(_react2.default.createElement(_components.ContactUsPopupContainer, {
        title: title,
        description: description,
        tag: tag,
        initialValues: {
          name: R.propOr("", "name", initialValues),
          email: R.propOr("", "email", initialValues),
          subject: R.propOr("", "subject", initialValues),
          comment: R.propOr("", "comment", initialValues)
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var platform = this.state.platform;
      var _props = this.props,
          softwares = _props.softwares,
          subscription = _props.subscription;
      var mixerUpdater = softwares.mixerUpdater;


      var latestStudio = (0, _utils.getLatestVersion)(mixerUpdater, platform);
      var macLink = typeof latestStudio !== "undefined" ? latestStudio.UrlMac : "";
      var windowsLink = typeof latestStudio !== "undefined" ? latestStudio.Url : "";
      var studioDownloadUrl = typeof latestStudio !== "undefined" ? platform.toLowerCase() === "windows" ? latestStudio.Url : latestStudio.UrlMac : "";
      var downlaodText = this.state.platform === "Windows" ? "WINDOWS" : "MAC";

      var mailTo = encodeURI("mailto:?subject=Quixel Mixer Download Link&body=Note to self: Remember to download Quixel Mixer the next time I am on my desktop machine.\n" + "Here are the download links —\n\n" + "Windows: " + windowsLink + "\n\n" + "Mac: " + macLink + "\n");

      var links = [];
      if (__CLIENT__ && (0, _utils.detectMobileAndTablet)()) {
        links = [{
          href: mailTo,
          label: "DOWNLOAD"
        }];
      } else {
        if (this.state.platform === "Linux") {
          links = [{
            href: "/products/mixer",
            label: "OTHER VERSIONS",
            newWindow: false
          }];
        } else {
          links = [{
            href: studioDownloadUrl,
            label: ("Download for " + this.state.platform).toUpperCase(),
            newWindow: true,
            onClick: function onClick() {
              if (window && _epicTracking) {
                window.trackEpicIntrection({
                  eventCategory: "Software",
                  eventAction: "Download",
                  eventLabel: "Mixer - " + latestStudio.Version,
                  interactionType: "click",
                  eventValue: 100
                });
              }
            }
          }, {
            href: "/products/mixer",
            label: "OTHER VERSIONS",
            newWindow: false
          }];
        }
      }

      var downloadLink = "";
      if (__CLIENT__ && (0, _utils.detectMobileAndTablet)()) {
        downloadLink = mailTo;
      } else {
        if (this.state.platform === "Linux") {
          downloadLink = "/products/mixer";
        } else {
          downloadLink = studioDownloadUrl;
        }
      }
      var switchingToUUNotAllowed = (0, _utils2.isSwitchingToUUNotAllowed)(subscription);

      return _react2.default.createElement(
        _components.AppSideEffects,
        {
          documentTitle: "Mixer - All-in-one texturing & material creation tool",
          documentImage: cf_utils.cf_thumbs("shareimage-mx.jpg"),
          documentDescription: "Quixel Mixer is the all-in-one 3D texturing tool that's fast to learn and easy to use. Download for free and create any material imaginable." },
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(_components.Hero, {
            bg: cf_utils.cf_qx_page("mixer", "Mixer_First_Frame.jpeg"),
            backgroundVideo: {
              poster: cf_utils.cf_qx_page("mixer", "Mixer_First_Frame.jpeg"),
              loop: "true",
              src: cf_utils.cf_qx_page("mixer", "Mixer-Website-Crunch.mp4")
            },
            superIconUrls: [cf_utils.cf_icons("mixer_icon_2048_preview.png")],
            title: "MIXER",
            subTitle: "TEXTURING MADE SIMPLE",
            primaryLabel: "",
            primaryTo: "",
            opacity: 0.25
            // secondaryLabel={'SUBSCRIBE'}
            // secondaryTo={downloadLink}

            , secondaryLabel: "DOWNLOAD NOW",
            secondaryTo: downloadLink,
            onClickSecondaryHandler: function onClickSecondaryHandler() {
              if (window && _epicTracking) {
                window.trackEpicIntrection({
                  eventCategory: "Software",
                  eventAction: "Download",
                  eventLabel: "Mixer - " + latestStudio.Version,
                  interactionType: "click",
                  eventValue: 100
                });
              }
            }
            // to={this.state.platform === 'Linux' || __CLIENT__ && detectMobileAndTablet()?'':studioDownloadUrl}

            // toolTip={!this.props.loggedIn?toolTip:null}
            // link={this.state.platform === 'Linux' || __CLIENT__ && detectMobileAndTablet() ? '' : 'Download Mixer (Free Beta)*'}
            // linkIcon={'download'}
            // toolTip={this.props.loggedIn ? null : toolTip}
            , linkIcon: this.props.loggedIn ? "rightSide" : "",
            link: this.props.loggedIn && {
              label: "View library",
              to: "/megascans/library/"
            }
            // to={this.state.platform === 'Linux' || __CLIENT__ && detectMobileAndTablet()?'':studioDownloadUrl}
          }),
          _react2.default.createElement(_components.DescriptionWith3Columns, {
            headingBeforeBreak: "One tool for a variety of texturing needs"
            // headingAfterBreak="TEXTURING IN ONE TOOL"
            , columns: [{
              img: cf_utils.cf_icons("intuitive_material_blanding.svg"),
              isIcon: false,
              title: "3D TEXTURING MADE EASY",
              desc: "Load your mesh, apply some Smart Materials, and 3D paint the finishing touches—it’s that easy. Take creative control and define your unique look, be it stylized, photoreal or beyond."
            }, {
              img: cf_utils.cf_icons("paint_mask_sculpt.svg"),
              isIcon: false,
              title: "CREATE AMAZING MATERIALS",
              desc: "Mix sculpting, painted layers and procedural masks with the entire Megascans library to create any material imaginable—all possible through one simple tool."
            }, {
              img: cf_utils.cf_icons("unrivaled_simplicity.svg"),
              isIcon: false,
              title: "EASY TO LEARN",
              desc: "Mixer is known for being extremely fun and easy to use, without compromising power or quality. You’ll love how straightforward Mixer is to use and adapt to your art style and vision."
            }]
          }),
          _react2.default.createElement(_components.VideoLinkSection, {
            typeLabel: "WHAT\u2019S NEW IN MIXER",
            YTid: "pLKSxRmY0NE",
            bg: cf_utils.cf_qx_page("megascans", "mixer_UE5.jpeg")
          }),
          _react2.default.createElement(_components.Feature, {
            featureType: "MIXER",
            newHome: true,
            images: [cf_utils.cf_qx_page("mixer", "product-page-mixer-carousel01-crunch.jpeg"), cf_utils.cf_qx_page("mixer", "product-page-mixer-carousel02-parking.jpeg"), cf_utils.cf_qx_page("mixer", "3d_texturing_2_2020_2.jpg"), cf_utils.cf_qx_page("mixer", "3d_texturing_4_2020.jpg"), cf_utils.cf_qx_page("mixer", "3d_texturing_3_2020_1.jpg")],
            title: "3D TEXTURING REINVENTED",
            desc: "Mixer combined with all of Megascans is set to help artists achieve revolutionary results. Texture your custom assets with multi-channel 3D painting, real-time 3D curvature, displacement sculpting, ID masking, procedural noises, seamless texture projection, Smart Materials and much more.",
            link: [{
              href: downloadLink,
              label: "DOWNLOAD MIXER",
              newWindow: true,
              onClick: function onClick() {
                if (window && _epicTracking) {
                  window.trackEpicIntrection({
                    eventCategory: "Software",
                    eventAction: "Download",
                    eventLabel: "Mixer - " + latestStudio.Version,
                    interactionType: "click",
                    eventValue: 100
                  });
                }
              }
            }]
            // artist={"Christopher Widdowson"}
            , artists: ["Wiktor Öhman / Christopher Widdowson", "James Lucas", "Juan Paulo Mardónez", "Marian Látečka", "Juan Paulo Mardónez"]
          }),
          _react2.default.createElement(_components.Feature, {
            featureType: "MIXER",
            newHome: true,
            images: [cf_utils.cf_qx_page("mixer", "create_any_surface_1_2020.jpg"), cf_utils.cf_qx_page("mixer", "create_any_surface_2_2020.jpg"), cf_utils.cf_qx_page("mixer", "create_any_surface_3_2020.jpg"), cf_utils.cf_qx_page("mixer", "create_any_surface_4_2020.jpg")],
            title: "CREATE ANY SURFACE IMAGINABLE",
            desc: "Mixer is versatile enough to allow you to work in the style of your choice. So whether you\u2019re looking to create the perfect snowy ground texture that fits with your game environment, or a highly-stylized Viking shield for your character, Mixer will help you get there in a matter of minutes.",
            flip: true,
            link: [{
              href: downloadLink,
              label: "DOWNLOAD MIXER",
              newWindow: true,
              onClick: function onClick() {
                if (window && _epicTracking) {
                  window.trackEpicIntrection({
                    eventCategory: "Software",
                    eventAction: "Download",
                    eventLabel: "Mixer - " + latestStudio.Version,
                    interactionType: "click",
                    eventValue: 100
                  });
                }
              }
            }],
            artist: "Wiktor Öhman",
            artists: ["Wiktor Öhman", "Eric Dinoware", "Wiktor Öhman", "Eric Dinoware"]
          }),
          _react2.default.createElement(_components.Feature, {
            featureType: "MIXER",
            newHome: true,
            images: [cf_utils.cf_qx_page("mixer", "smart_materials_1_2020_1.jpg"), cf_utils.cf_qx_page("mixer", "smart_materials_2_2020_1.jpg"), cf_utils.cf_qx_page("mixer", "smart_materials_3_2020_1.jpg")],
            title: "MEGASCANS-BASED SMART MATERIALS",
            desc: "The free Smart Materials that come with Mixer adapt realistically to your 3D assets, with photoreal material definition, dirt accumulation, and wear and tear. The secret is combining dynamic real-time baking and customizable procedural masking with the awesome power of the Megascans library.",
            link: [{
              href: downloadLink,
              label: "DOWNLOAD MIXER",
              newWindow: true,
              onClick: function onClick() {
                if (window && _epicTracking) {
                  window.trackEpicIntrection({
                    eventCategory: "Software",
                    eventAction: "Download",
                    eventLabel: "Mixer - " + latestStudio.Version,
                    interactionType: "click",
                    eventValue: 100
                  });
                }
              }
            }]
          }),
          _react2.default.createElement(_components.Feature, {
            featureType: "MIXER",
            newHome: true,
            images: [cf_utils.cf_qx_page("mixer", "creative_ownership_1_2020.jpg"), cf_utils.cf_qx_page("mixer", "creative_ownership_2_2020.jpg"), cf_utils.cf_qx_page("mixer", "creative_ownership_3_2020.jpg")],
            title: "TAKE CREATIVE OWNERSHIP",
            desc: "With painting, sculpting, blending and procedural masking all-in-one, you have the power to create amazing seamless surfaces of any kind in no-time, with total control and art direction. Don\u2019t waste your time on overly technical tools\u2014get results faster with Mixer.",
            flip: true,
            link: [{
              href: downloadLink,
              label: "DOWNLOAD MIXER",
              newWindow: true,
              onClick: function onClick() {
                if (window && _epicTracking) {
                  window.trackEpicIntrection({
                    eventCategory: "Software",
                    eventAction: "Download",
                    eventLabel: "Mixer - " + latestStudio.Version,
                    interactionType: "click",
                    eventValue: 100
                  });
                }
              }
            }]
          }),
          _react2.default.createElement(
            _Slider2.default,
            { delay: 7 },
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("javier-perez.jpg"),
              icon: cf_utils.cf_testimonials("icon/intrepid.png"),
              title: "\u201CI find Mixer to be super powerful. Seeing all the channels updating live is a great way to quickly iterate your textures.\u201D",
              subTitle: "\u2014 Javier Perez, Senior Environment Artist, Intrepid Studios",
              hr: true
            }),
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("dice-test.jpg"),
              icon: cf_utils.cf_testimonials("icon/dice.png"),
              title: "\u201CMixer is a refreshing take on how to work with scanned materials. We used Mixer during the production of Battlefield V to create a wide range of terrain materials and mixes.\u201D",
              subTitle: "\u2014 Pontus Ryman, Senior Environment Artist, EA DICE",
              hr: true
            })
          ),
          _react2.default.createElement(_components.Feature, {
            featureType: "MIXER",
            newHome: true,
            img: cf_utils.cf_qx_page("mixer", "complete_megascans_integration_UE5.jpeg"),
            title: "COMPLETE MEGASCANS INTEGRATION",
            desc: "Instantly access the Megascans library directly within Mixer. Leverage Megascans to guarantee photorealistic base textures or transform them into fantastic stylized assets effortlessly. Mixer and Megascans together give you virtually limitless creative possibilities.",
            link: [{
              href: "https://www.youtube.com/watch?v=wThyDisLyH0",
              label: "WATCH THE WORKFLOW PRIMER",
              newWindow: true
            }]
          }),
          _react2.default.createElement(_components.Feature, {
            featureType: "MIXER",
            newHome: true,
            img: cf_utils.cf_qx_page("mixer", "product-page-buddha.jpeg"),
            title: "ZERO LEARNING CURVE",
            desc: "Built around simplicity, Mixer is designed to be intuitive and extremely fast for anyone who just wants to make art. Create stunning mixes in minutes, or texture advanced assets with incredible control\u2014whether you are in a hurry or want to dive deep, Mixer has got you covered.",
            link: [{
              href: "https://www.youtube.com/watch?v=ZCPnmRcfsqw",
              label: "How to Create a Material in 1 minute",
              newWindow: true
            }],
            flip: true,
            artist: "Christopher Widdowson"
          }),
          _react2.default.createElement(_components.Feature, {
            featureType: "MIXER",
            newHome: true,
            img: cf_utils.cf_qx_page("mixer", "product-page-coffee-table.jpeg"),
            title: "OWN YOUR CREATIVITY",
            desc: "Play around with Mixer and hundreds of included Smart Materials and Megascans assets. In addition to that, Unreal Engine users can leverage any supported Megascans assets for their everyday texture needs.",
            link: [{
              href: downloadLink,
              label: "DOWNLOAD MIXER",
              newWindow: true,
              onClick: function onClick() {
                if (window && _epicTracking) {
                  window.trackEpicIntrection({
                    eventCategory: "Software",
                    eventAction: "Download",
                    eventLabel: "Mixer - " + latestStudio.Version,
                    interactionType: "click",
                    eventValue: 100
                  });
                }
              }
            }],
            artist: "Christopher Widdowson"
          }),
          _react2.default.createElement(_components.Feature, {
            featureType: "MIXER",
            newHome: true,
            img: cf_utils.cf_qx_page("mixer", "bridge-logos-UE5.jpg"),
            title: "JOIN A VIBRANT AND OPEN<br/>ECOSYSTEM",
            desc: "With Unreal Engine, Megascans, Bridge and Blender at your disposal, Mixer closes the missing link in your creative toolset, paving the way for a new breed of creative tools that are centered around community and available for free.",
            flip: true,
            link: links
          })
        )
      );
    }
  }]);
  return Mixer;
}(_react2.default.Component), _class2.contextTypes = {
  dialogs: _react2.default.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = Mixer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Apps/Mixer.jsx
// module id = 2882
// module chunks = 0